import { useContext, useState } from 'react'
import { privacyUrl } from '../../../../Common/Constants'
import Checkbox from '../../../../Components/Checkbox/Checkbox'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import { NavigationNode } from '../../Services/Navigation'
import { validateEmail, validatePhoneNumber } from '../../Services/Validation'
import ViewType from '../../Types/ViewType'
import API from "../../Services/API"
import './EnterEmailView.css'

const EnterEmailView = () => {
	let context = useContext(ConfiguratorContext)

	let [email, setEmail] = useState(context.email)
	let [emailConfirmation, setEmailConfirmation] = useState(context.email)
	let [emailAlreadyExists, setEmailAlreadyExists] = useState(false)
	let [emailAlreadyExistsError, setEmailAlreadyExistsError] = useState("")
	let [emailError, setEmailError] = useState("")
	let [emailConfirmationError, setEmailConfirmationError] = useState("")
	let [pec, setPec] = useState(context.pec)
	let [pecError, setPecError] = useState("")
	let [pecAlreadyExists, setPecAlreadyExists] = useState(false)
	let [pecAlreadyExistsError, setPecAlreadyExistsError] = useState("")
	let [phone, setPhone] = useState(context.phone)
	let [phoneError, setPhoneError] = useState("")
	let [privacy, setPrivacy] = useState(context.privacy)
	let [privacyError, setPrivacyError] = useState("")

	context.validateEnterEmail = () => {
		let validEmail = validateEmail(email ?? "")
		setEmailError(validEmail ? "" : "Email non valida")

		checkEmail()

		let validEmailConfirmation = validateEmail(emailConfirmation ?? "")
		if (!validEmailConfirmation) {
			setEmailConfirmationError(validEmailConfirmation ? "" : "Email di conferma non valida")
		} else {
			validEmailConfirmation = email === emailConfirmation
			setEmailConfirmationError(validEmailConfirmation ? "" : "Le due email inserite sono differenti")
		}

		let validPec = validateEmail(pec ?? "")
		if (!context.isHomeUse) {
			checkPec()
		}

		let validPhone = validatePhoneNumber(phone ?? "")
		setPhoneError(validPhone ? "" : "Numero non valido")

		setPrivacyError(privacy ? "" : "E' obbligatorio accettare l'informativa sulla privacy")

		context.email = email
		context.pec = pec
		context.phone = phone
		context.privacy = privacy

		if (context.isHomeUse) {
			return privacy && validEmail && validEmailConfirmation && validPhone && !emailAlreadyExists
		} else {
			return privacy && validEmail && validEmailConfirmation && validPhone && !emailAlreadyExists
				&& validPec && !pecAlreadyExists
		}
	}

	async function checkEmail() {
		let res = await API.checkEmailAsync({ first_name: context.name!, last_name: context.surname!, email: email! })
		if (res.success) {
			if (res.data) {
				setEmailAlreadyExists(false)
				setEmailAlreadyExistsError('')
			} else {
				setEmailAlreadyExists(true)
				setEmailAlreadyExistsError('Questa email è già stata utilizzata da un altro utente')
			}
		}
	}

	async function checkPec() {
		let res = await API.checkPecAsync({ first_name: context.name!, last_name: context.surname!, email: email!, pec: pec! })
		if (res.success) {
			if (res.data) {
				setPecAlreadyExists(false)
				setPecAlreadyExistsError('')
			} else {
				setPecAlreadyExists(true)
				setPecAlreadyExistsError('Questa Pec è già stata utilizzata da un altro utente')
			}
		}
	}

	function PecInput() {
		if (!context.isHomeUse) {
			return (
				<div className='enter-email-input-container'>
					<div className="enter-email-title">Inserisci la tua pec</div>
					<div className='input-error'>
						<input onChange={e => setPec(e.target.value.trim().split(" ").join(""))} value={pec} onBlur={checkPec} className="enter-email-input" />
						<div className='label-error'>{pecError}</div>
						<div className='label-error'>{pecAlreadyExistsError}</div>
					</div>
				</div>
			)
		}
	}

	return (
		<div className="enter-email-container">
			<div className='enter-email-input-container'>
				<div className="enter-email-title">Inserisci la tua email</div>
				<div className='input-error'>
					<input onChange={e => setEmail(e.target.value.trim().split(" ").join(""))} value={email} onBlur={checkEmail} className="enter-email-input" />
					<div className='label-error'>{emailError}</div>
					<div className='label-error'>{emailAlreadyExistsError}</div>
				</div>
			</div>

			<div className='enter-email-input-container'>
				<div className="enter-email-title">Conferma la tua email</div>
				<div className='input-error'>
					<input onChange={e => setEmailConfirmation(e.target.value.trim().split(" ").join(""))} value={emailConfirmation} className="enter-email-input" />
					<div className='label-error'>{emailConfirmationError}</div>
				</div>
			</div>

			{PecInput()}

			<div className='enter-email-input-container'>
				<div className="enter-email-title">Inserisci il tuo numero di telefono</div>
				<div className='input-error'>
					<input onChange={e => setPhone(e.target.value.trim().split(" ").join(""))} value={phone} className="enter-email-input" />
					<div className='label-error'>{phoneError}</div>
				</div>
			</div>

			<div className='enter-email-privacy-block'>
				<Checkbox checked={privacy} onChange={_ => setPrivacy(!privacy)} title='' horizontal />
				<div>Accetto la <a className='enter-email-privacy-ref' rel="noreferrer" target="_blank" href={privacyUrl}>privacy policy</a></div>
				<div className='label-error'>{privacyError}</div>
			</div>
			<div style={{ height: "100px" }} />
		</div>
	)
}

const EnterEmailNode: NavigationNode = {
	content: () => <EnterEmailView />,
	next: () => ViewType.secondDataPage,
	previous: (context: Configuration) => ViewType.firstDataPage,
	percentage: 40
}

export default EnterEmailNode
